import React from 'react'
import { RouteComponentProps } from 'react-router'

import { ReportRequest } from './ReportRequest'
import { ReportRequestData } from './common'
import { DynamicReport } from './DynamicReport'
import { Card } from './Card'
import { ContactForm } from './ContactForm'

import ReactGA from 'react-ga'
ReactGA.initialize('UA-1244143-21')

interface Props extends RouteComponentProps<{}> {
  // 他の型定義
}

interface State { }

export class NewReport extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.start = this.start.bind(this)
    this.state = {
    }
  }

  async start(data: ReportRequestData) {
    ReactGA.event({
      label: data.strategy,
      action: 'submit',
      category: data.url
    })

    this.props.history.push({
      pathname: '/report',
      search: new URLSearchParams({
        url: data.url || 'sample',
        strategy: data.strategy as string || 'mobile',
      }).toString()
    })
  }

  public render() {
    return (
      <div className="container">
        <Card title={`🆓 無料で作成！ PageSpeed Insights 試験対策の特別レポート`}>
          <p className="alert alert-primary">PageSpeed Insightsのレポートを見ても、なぜそのスコアなのか、具体的な弱点は何か、そもそもスコアにどういう意味があるのかよくわかりません。まずはスコアが上がらないと楽しくない！ということでモヤモヤに応える試験対策の特別レポートを作成します。</p>
          <ReportRequest onStart={this.start}></ReportRequest>
        </Card>

        <h4 className="alert mb-4 text-center">↓ こんなレポートを作成します ↓</h4>

        <Card title="PageSpeed Insights 試験対策 https://toyota.jp/ (サンプル)">
          <div className="alert alert-primary mb-4">2020年5月現在の<a href="https://toyota.jp/">トヨタ自動車</a>トップページを例としたサンプルレポートです。</div>
          <DynamicReport url="sample" strategy="mobile"></DynamicReport>
        </Card>

        <ContactForm></ContactForm>

        {/* <Card title="このレポートツールについて">
          <p>弊社では<a href="https://www.ideamans.com/lp1/lightfile-bot/">画像ファイルの自動軽量化AIソリューション LightFile</a>を提供しています。2018年ごろから、「画像を軽量化するとPageSpeed Insightsのスコアはどのくらい上がりますか？」と聞かれることが増えました。</p>
          <p>そのことをきっかけにPageSpeed Insightsについて研究を重ね、スコア改善コンサルティングも手がけることになりました。</p>
          <p>PageSpeed Insightsは <code>なぜそのスコアになるのか理由がわからない</code> と言われます。これは確かに<code>模試の平均点だけを知らされるようなもの</code>で、科目ごとの成績がわからないと具体的な対策ができません。</p>
          <p>レポートに表示されるアドバイスは、ベストプラクティスとしては有益であるものの、スコアに直接は関係がないため混乱を助長しています。</p>
          <p>スコアも実際のところ一面的な指標のひとつにすぎません。しかし仕組みや理由がわからないモヤモヤを抱えたままでは意思決定が鈍り、試みが数値に現れる方がまずは楽しく改善に取りかかれます。</p>
          <p>このツールは、<code>スコアアップという試験対策を主目的としたPageSpeed Insightsの裏レポートを作成</code>します。</p>
        </Card> */}

      </div >
    )

  }
}
